import Const from 'constants';

let UniquePlayersQuantity = {
    setUniquePlayersQuantityFromStorage(value) {
        return (dispatch) => {
            dispatch(this.setUniquePlayersQuantity(value, {saveToStorage: false}));
        };
    },

    setUniquePlayersQuantity(value, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.SET_UNIQUE_PLAYERS_QUANTITY,
                    value,
                });

            saveToStorage && dispatch(
                this.saveDataToStorage('uniquePlayersQuantity', function (state) {
                    const {uniquePlayersQuantity} = state;
                    return uniquePlayersQuantity.getUniquePlayersQuantity();
                }),
            );
        };
    },
};

export default UniquePlayersQuantity;
